import {
  irelandMapPins,
  pharmacyAiLinks,
} from "views/components/pages/PharmacyAI/constants";
import { PageContainer } from "views/components/pages/PharmacyAI/layout";
import {
  ChartDeco,
  DemoButton,
  ImpactCard,
  ImpactCardBody,
  IrelandMapImage,
  IrelandSectionWrap,
  MapHeading,
  MapInner,
  MapPinsLayer,
  MapPinsSvg,
  MapRow,
  MapVisual,
} from "./styles";

const chartHeights = [40, 65, 50, 80, 55, 90, 70];

const IRELAND_MAP_SRC = `${process.env.PUBLIC_URL}/images/ireland-outline.svg`;

const IrelandSection = () => {
  return (
    <IrelandSectionWrap>
      <PageContainer>
        <MapRow>
        <MapVisual>
          <MapInner>
            <IrelandMapImage
              src={IRELAND_MAP_SRC}
              alt="Map of Ireland showing Taskgo pharmacy locations"
            />
            <MapPinsLayer aria-hidden>
              <MapPinsSvg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">
                {irelandMapPins.map((pin, i) => (
                  <circle
                    key={`pin-${i}`}
                    cx={pin.left}
                    cy={pin.top}
                    r="0.85"
                    fill="#4A93CF"
                  />
                ))}
              </MapPinsSvg>
            </MapPinsLayer>
          </MapInner>
        </MapVisual>
        <MapHeading>
          Proudly helping pharmacies across Ireland
        </MapHeading>
      </MapRow>

      <ImpactCard>
        <ImpactCardBody>
          <p className="eyebrow">Our impact on pharmacies</p>
          <p className="stat">15,000 Euros +</p>
          <p className="subtext">Savings for pharmacies</p>
          <DemoButton
            to={pharmacyAiLinks.demoContact}
            aria-label="Request a pharmacy AI demo via the contact form"
          >
            Request A Demo ↗
          </DemoButton>
        </ImpactCardBody>
        <ChartDeco aria-hidden>
          {chartHeights.map((h, i) => (
            <span key={i} style={{ height: `${h}px` }} />
          ))}
        </ChartDeco>
        </ImpactCard>
      </PageContainer>
    </IrelandSectionWrap>
  );
};

export default IrelandSection;
